'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroHeading = require('./NitroHeading');

var _NitroHeading2 = _interopRequireDefault(_NitroHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroHeading2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-heading/index.js
// module id = 13
// module chunks = 4